import styled from 'styled-components';

const NODE_HANDLE_RADIUS = 14;

export const NodeWrapper = styled.div<{ $isSelected: boolean }>`
  outline: ${(props) => (props.$isSelected ? `2px solid ${props.theme.global.mainColor}` : 'none')};
  border-radius: 4px;

  .source-handle,
  .target-handle {
    opacity: 1;
    width: ${`${NODE_HANDLE_RADIUS}px`};
    height: ${`${NODE_HANDLE_RADIUS}px`};
    border: 2px solid
      ${(props) => (props.$isSelected ? props.theme.global.mainColor : props.theme.ui.input.borderColor)};
    background-color: #ffffff;
    transform: scale(1);
  }

  .source-handle:hover,
  .target-handle:hover,
  .target-handle.connecting,
  .source-handle.connecting {
    border-color: ${(props) => props.theme.global.mainColor};
  }

  .source-handle.right {
    top: ${`calc(50% - ${NODE_HANDLE_RADIUS / 2}px)`};
    right: ${`-${NODE_HANDLE_RADIUS / 2}px`};
  }
  .source-handle.bottom {
    bottom: ${`-${NODE_HANDLE_RADIUS / 2}px`};
    left: ${`calc(50% - ${NODE_HANDLE_RADIUS / 2}px)`};
  }
  .target-handle.top {
    top: ${`-${NODE_HANDLE_RADIUS / 2}px`};
    left: ${`calc(50% - ${NODE_HANDLE_RADIUS / 2}px)`};
  }
  .target-handle.left {
    top: ${`calc(50% - ${NODE_HANDLE_RADIUS / 2}px)`};
    left: ${`-${NODE_HANDLE_RADIUS / 2}px`};
  }
`;

export const NodeHeader = styled.div<{ $color?: string }>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 10px;
  font-size: 14px;
  font-weight: 500;
  gap: 20px;

  ${(props) => {
    if (props.$color) {
      return {
        backgroundColor: props.$color,
      };
    }
  }}
`;

export const NodeContainer = styled.div<{ $color?: string; $minWidth?: number }>`
  position: relative;
  min-width: ${(props) => (props.$minWidth ? `${props.$minWidth}px` : '220px')};
  font-size: 14px;
  font-weight: 500;
  border: 1.5px solid ${(props) => (props.$color ? props.$color : props.theme.global.borderColor)};
  border-radius: 4px;

  ${NodeHeader} {
    background-color: ${(props) => (props.$color ? props.$color : props.theme.ui.button.iconButtonBgColor)};
    color: ${(props) => (props.$color ? '#ffffff' : props.theme.global.textColor)};
  }
`;

export const NodeBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  background-color: ${(props) => props.theme.global.bgColor};
  padding: 8px;
  padding-left: 12px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
`;

export const NodeNameView = styled.div`
  display: flex;
  align-items: center;
  font-size: 13px;
  gap: 6px;
`;

export const NodeInOutTag = styled.span`
  position: relative;
  left: -4px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #ffffff;
  width: 40px;
`;

export const NodeButtonView = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  button,
  a {
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      font-size: 22px;
    }
  }
`;

export const NodeExpandButton = styled.button`
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 18px;
`;

export const NodeIcon = styled.div`
  img {
    width: 20px;
  }
`;
